/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import DataTable from "../DataTable";
import LoadingAlert from "../LoadingAlert";
import Paging from "../Paging";
import { qreq } from "../../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Alert from "../Alert";
import { SidebarGlobal } from "../_SidebarGlobal";
import Tick from "../Tick";
import Auth from "../../shared/Auth";
import './WorkorderList.css';
import React from "react";
import Globals from "../../shared/Globals";
import { WorkorderCom } from "./WorkorderCom";
import Icon from "../Icon";
import L from "../Lang";


class WorkorderList extends WorkorderCom {

    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loaded: false,
            loading: true,
            pageCount: 0,
            page: props.params ? props.params.page ?? 1 : 1,
            search: '',
            lastSearch: '',
            filters: {},
            query: {}
        };
        this.importRef = React.createRef();
    }

    componentDidMount() {
        this.load();
        this.fillListAsync('/api/account/list', 'accounts');
        this.fillListAsync('/api/project/list', 'projects', true);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.page !== this.props.params.page) {
            this.state.page = Number(this.props.params.page);
            this.setState({ query: this.state.query });
            this.load();
        }
    }

    load = (search, sort, query) => {
        this.setState({ loading: true });
        qreq.post('/api/workorder/list?page=' + this.state.page
            + (search ? '&search=' + encodeURIComponent(search) : '')
            + (sort ? '&sort=' + sort : '')
            , query || {}
            , j => {
                if (j.list) {
                    this.processList(j.list);
                    this.setState({ list: j.list, pageCount: j.pageCount });
                }
                else if (j.errorCode !== 0)
                    this.setState({ errorMessage: j.errorMessage });
                this.setState({ loaded: true, loading: false });
            }, () => {
                this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
            });
    }

    filter = (col) => {
        var filters = { ...this.state.filters };
        if (col.filter.value)
            filters[col.filter.id] = col.filter.value;
        else
            delete filters[col.filter.id];
        var query = { ...this.state.query, qfilters: filters };
        this.setState({ filters: filters, query: query });
        this.load(this.state.search, this.state.sort, query);
    }

    toggleFilter = () => {
        this.setState({ showFilters: !this.state.showFilters });
    }

    processList = (list) => {
        list.forEach(i => {
            if (i.statusName === 'Closed') i.className = 'wo-closed';
            else if (i.statusName === 'On Hold') i.className = 'wo-onhold';
        });
    }

    search = (e) => {
        this.setState({ search: e.target.value });
    }

    import = () => {
        this.importRef.current.click();
    }

    importUpload = (e) => {
        if (e.target.files.length) {
            var reader = new FileReader();
            reader.addEventListener('progress', e => {
            });
            reader.onload = () => {
                let p = reader.result.split(',');
                this.doImportUpload(p[1]);
            }
            reader.readAsDataURL(e.target.files[0]);
        }
        this.importRef.current.value = '';
    }

    export = () => {
        window.open(Globals.serverUrl + '/api/workorder/export/csv/workorders.csv');
    }

    doImportUpload = async (data) => {
        try {
            let j = await qreq.postAsync('/api/workorder/import', { base64Content: data });
            if (j.errorCode === 0)
                this.success('Import success!');
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    tick = () => {
        if (this.state.search !== this.state.lastSearch) {
            this.setState({ lastSearch: this.state.search });
            this.load(this.state.search, this.state.sort, this.state.query);
        }
    }

    sort = (col) => {
        let name = col.name;

        let sort = name + ' ' + (col.asc ? 'ASC' : 'DESC');
        this.setState({ sort });
        this.load(this.state.search, sort, this.state.query);
    }

    render() {
        SidebarGlobal.setSubNav(<><div className="btn-group">
            {!Auth.hasRole('readonly') && <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/workorder/new')}>
                <FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Work Order</L></span>
            </button>}
            {Auth.hasRole('admin') && <button type="button" className="btn btn-secondary" onClick={() => this.import()}>
                <FontAwesomeIcon icon={fa.faFileImport} /> <span className="d-none d-md-inline"><L>Import</L></span>
            </button>}
            {Auth.hasRole('admin') && <button type="button" className="btn btn-secondary" onClick={() => this.export()}>
                <FontAwesomeIcon icon={fa.faFileCsv} /> <span className="d-none d-md-inline"><L>Export</L></span>
            </button>}
            <button type="button" className={'btn ' + (this.state.showFilters ? 'btn-warning' : 'btn-secondary')} onClick={() => this.toggleFilter()}>
                <Icon icon="faFilter" /> <span className="d-none d-md-inline"><L>Filter</L></span>
            </button>
        </div></>);


        const header = (<h1><L>Work Orders</L></h1>);
        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            { name: 'id', title: 'ID', link: '/workorder/:id' },
            {
                name: 'name', title: 'Workorder', link: '/workorder/:id',
                valueFunc: row => {
                    let name = [];
                    name.push(<>{row.name}</>);
                    if (row.projectName)
                        name.splice(0, 0, <><span className="fw-bold">{row.projectName}</span><span> </span></>);
                    if (row.priorityLevel && row.statusName !== 'Closed') {
                        name.push(<span> </span>);
                        name.push(this.priority(row.priorityLevel));
                    }
                    return name;
                }
            },
            {
                name: 'statusName', title: 'Status', valueFunc: row => {
                    return row.statusName ?? <i><L>Unknown</L></i>;
                }
            },
            {
                name: 'typeName', title: 'Type', valueFunc: row => {
                    return row.typeName ?? <i><L>Unknown</L></i>;
                },
                className: 'd-none d-md-table-cell'
            }


        ];

        if (Auth.hasRole('tasker')) {
            columns.push({
                name: 'accountName', title: 'Account', valueFunc: row => {
                    return row.accountName ?? <i><L>No Account</L></i>;
                },
                className: 'd-none d-md-table-cell'
            })
            columns.push({
                name: 'reportToName', title: 'Report To', valueFunc: row => {
                    return row.reportToName ?? <i><L>Not Assigned</L></i>
                },
                className: 'd-none d-md-table-cell'
            });
            columns.push({
                name: 'percentComplete', title: '%', valueFunc: row => {
                    if (row.statusName === 'Closed')
                        row.percentComplete = 100;
                    return <div style={{ width: '100%', border: '1px solid #000', height: '1rem', overflow: 'hidden' }} className="bg-light">
                        <div style={{ width: row.percentComplete + '%', height: '1rem' }} className={row.percentComplete > 50
                            ? 'bg-success' : row.percentComplete > 25 ? 'bg-warning' : 'bg-danger'}>
                        </div>
                    </div>;
                }
            });
            columns.push({ name: 'dueDate', title: 'Due Date', format: 'date', className: 'd-none d-md-table-cell' });
        }


        return <div className="container-fluid">
            {header}
            <input type="file" ref={this.importRef} className="d-none" onChange={this.importUpload} />
            <div className="mb-3">
                <input type="text"
                    className={'form-control' + (this.state.search ? ' bg-info' : '')}
                    placeholder="Search..."
                    onChange={this.search}
                    value={this.state.search}
                />
            </div>
            <Tick onTick={this.tick} />
            <DataTable noStriped columns={columns}
                data={this.state.list} totalCount={this.state.totalCount}
                loading={this.state.loading} onSort={this.sort}
                defaultSort="createdDate" defaultSortDesc
                filters={[
                    {
                        id: 'w.projectID',
                        name: 'name',
                        title: 'Project',
                        type: 'select',
                        options: this.state.projects
                    },
                    {
                        id: 'w.accountID',
                        name: 'accountName',
                        title: 'Account',
                        type: 'select',
                        options: this.state.accounts
                    }
                ]}
                onFilter={this.filter}
                showFilters={this.state.showFilters}
            />
            <div className="card-body">
                <Paging baseLoc="/workorder/page/" pageCount={this.state.pageCount} currentPage={this.state.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(WorkorderList);